<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect === 'noredirect' || index === levelList.length - 1" class="no-redirect" v-html="item.meta.title"></span>
        <router-link v-else :to="item.redirect || item.path" v-html="item.meta.title"></router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{
          path: '/home',
          meta: {
            title: '<img src="/static/svg/home.svg" alt="首页" style="width: 15px; height: 15px;" />'
          }
        }].concat(matched)
      }else if (first && first.name === 'home') {
        // 如果首页在导航中，将其替换为SVG图标
        //first.meta.title = '<img src="/static/svg/home.svg" alt="首页" style="width: 20px; height: 20px;" />'
      } 
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    color: #000;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue